function Diamond4(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M240 0H0v240l240 240h240V240L240 0z"></path></svg>
    )
}
export default Diamond4